import { Component,ViewChild } from '@angular/core';
import { IonicPage, Events, Tabs, NavController, NavParams, ModalController } from 'ionic-angular';
import { AccountPage } from '../account/account';
import { NotificationsPage } from '../notifications/notifications';
import { ChatListPage } from '../chat-list/chat-list';
import { EventsPage } from '../events/events';
import { ExplorePage } from '../explore/explore';
import { LoginModalPage } from '../login-modal/login-modal';

import { AuthProvider } from '../../providers/auth/auth.provider';
import { MapPage } from '../map/map';

/**
 * Generated class for the TabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage {

  @ViewChild('myTabs') tabRef: Tabs;

  tab1Root = EventsPage;
  tab2Root = MapPage;
  tab3Root = ExplorePage;
  tab4Root = AccountPage;
  
  accountRoot = AccountPage;
  cardSelectorModal: any;

  isLogged: Boolean;

  constructor(
    public navCtrl: NavController, 
    public events: Events,
    public modalCtrl: ModalController, 
    public authProvider: AuthProvider, 
    public navParams: NavParams) 
  {
    
    this.cardSelectorModal = this.modalCtrl.create(LoginModalPage,{});
    this.events.subscribe('user:login',() => {
      this.accountRoot = this.tab4Root;
      // console.log("tabs listenToEvents : user:login", this.isLogged);
      this.cardSelectorModal.dismiss();
    });
    this.events.subscribe('user:logout',() => {
      console.log("tabs subscribe user:logout");
      // this.tabRef.select(0);
      // this.accountRoot = null;
    });
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad TabsPage');
    if(!this.authProvider.isConnected()){
      this.accountRoot = null;
      // console.log("accountRoot null");
    }
  }

  checkLogin(){
    // console.log('checkLogin');
    if(this.authProvider.isConnected()){
      // console.log('checkLogin connected');
      this.accountRoot = this.tab4Root;
      // console.log(document.getElementById('tab-t0-4'));
      // setTimeout(() => {
      //   document.getElementById('tab-t0-4').click();
      // },200);
      return true;
    }
    else {
      // console.log('checkLogin offline');
      this.cardSelectorModal.onDidDismiss(data => {
        // console.log("data",data);
        if(data != null){
        }
      });
      this.cardSelectorModal.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts